/**
 * Базовые монеты для фильтрации
 * @type {Object.<string, {id: number, displayName: string}>}
 */
export const BASE_COINS_LIST = {
  'USD': {
    id: 1,
    displayName: 'USD',
    chartSlug: 'BTC',
    type: 'coin',
    icon: require('@/Groups/Scanner/private/media/context/btc.svg'),
  },
  'BTC': {
    id: 1,
    displayName: 'BTC',
    chartSlug: 'BTC',
    type: 'coin',
    icon: require('@/Groups/Scanner/private/media/context/btc.svg'),
  },
  'IMOEX': {
    id: -116,
    displayName: 'IMOEX',
    chartSlug: 'IMOEX',
    type: 'stock',
    icon: require('@/Groups/Scanner/private/media/context/moex.svg'),
  },
  'SP500': {
    id: -10005,
    displayName: 'S&P 500',
    chartSlug: 'SP500',
    type: 'asset',
    icon: require('@/Groups/Scanner/private/media/context/sp500.svg'),
  },
  'RUB': {
    id: -10006,
    displayName: 'RUB',
    chartSlug: 'RUB',
    type: 'asset',
    icon: require('@/Groups/Scanner/private/media/context/usdrub.svg'),
  },
};


/**
 * Данные для селекта базовых монет
 * @type {Array<{label: string, value: string}>}
 */
export const DATA_FOR_BASE_COINS_SELECT = Object.entries(BASE_COINS_LIST).map(([slug, item]) => ({
  label: item.displayName,
  value: slug,
}));


/**
 * Данные для селекта переключения валюты
 * @type {Array<{label: string, value: string}>}
 */
export const DATA_FOR_CURRENCY_SELECT = [
  { label: 'USD', value: 'usd' },
  { label: 'RUB', value: 'rub' },
];


/**
 * Категории фильтрации
 * @type {Object.<string, {param: string, label: string, icon: string}>}
 */
export const CATEGORIES_LIST = {
  'crypto_100': {
    param: 'top=100',
    assetType: 'coin',
    label: 'Crypto 100',
    icon: require('@/Groups/Scanner/private/media/categories/web.png'),
  },
  'crypto_300': {
    param: 'top=300',
    assetType: 'coin',
    label: 'Crypto 300',
    icon: require('@/Groups/Scanner/private/media/categories/web.png'),
  },
  'top_assets': {
    param: 'top_assets=true',
    assetType: 'top_asset',
    label: 'Top Assets',
    icon: require('@/Groups/Scanner/private/media/categories/planet.png'),
  },
  'ru': {
    param: 'stocks=true',
    assetType: 'stock',
    label: 'RU',
    icon: require('@/Groups/Scanner/private/media/categories/russia.png'),
  },
  'usa': {
    param: 'top_usa_assets=true',
    assetType: 'top_asset',
    label: 'USA',
    icon: require('@/Groups/Scanner/private/media/categories/usa.png'),
  },
  'commodities': {
    param: 'commodities=true',
    assetType: 'commodity',
    label: 'Сырьё',
    icon: require('@/Groups/Scanner/private/media/categories/oil.png'),
  },
  'briefcase': {
    param: 'user_assets=true',
    assetType: null,
    label: 'Портфель',
    icon: require('@/Groups/Scanner/private/media/categories/briefcase.png'),
  },
}


/**
 * Временные периоды
 * @type {Object.<string, string>}
 */
export const TIME_PERIODS = {
  '1d': '24ч',
  '1w': '7д',
  '1m': '1м',
  '3m': '3м',
  '6m': '6м',
  'ytd': 'Ytd',
  '1y': '1г',
  '2y': '2г',
  '3y': '3г',
  '4y': '4г',
  '5y': '5г',
};

/**
 * Словарь заголовков для динамики
 */
export const TABLE_TITLE_DYNAMICS = {
  '1d': 'Динамика за 24 часа',
  '1w': 'Динамика за 7 дней',
  '1m': 'Динамика за 1 месяц',
  '6m': 'Динамика за 6 месяцев',
  'ytd': 'Динамика с начала года',
  '1y': 'Динамика за 1 год',
}

/**
 * Словарь сокращенных названий месяцев (для форматирования дат)
 */
export const MONTHS_SHORT = {
  'янв': 'января',
  'фев': 'февраля',
  'мар': 'марта',
  'апр': 'апреля',
  'май': 'мая',
  'июн': 'июня',
  'июл': 'июля',
  'авг': 'августа',
  'сен': 'сентября',
  'окт': 'октября',
  'ноя': 'ноября',
  'дек': 'декабря'
};

/**
 * Список ID монет с особым визуальным выделением.
 * Эти монеты отображаются с специальным стилем в интерфейсе скринера.
 */
export const HIGHLIGHTED_COIN_IDS = [1, 2, 19067, 4139];

/**
 * PAXG (id: 4139) отображается как GOLD
 */
export const SYMBOL_OVERRIDES = {
  4139: 'GOLD'
};
